export const colorsForDashboard = ["#ADD8E6", "#98FB98", "#FDFD96", "#DDA0DD", "#FFB6C1", "#FFDAB9"];
export const getColorForDashboard = (index: number) => {
    return colorsForDashboard[index % colorsForDashboard.length];
}
